import type { ChangeEventHandler } from 'react';
import type { CheckboxProps } from '../../../components/Checkbox/Checkbox';

import { useCallback } from 'react';

import Checkbox from '../../../components/Checkbox/Checkbox';

import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const CheckboxField = ({ indeterminate, ...props }: CheckboxProps) => {
  const field = useFieldContext<boolean>();
  const errors = useFieldErrors(field.name);

  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      if (indeterminate) {
        field.handleChange(true);
        return true;
      } else field.handleChange(e.target.checked);
    },
    [field, indeterminate],
  );

  return (
    <Checkbox
      {...props}
      name={field.name}
      checked={field.state.value}
      onChange={onChange}
      onBlur={field.handleBlur}
      indeterminate={indeterminate}
      error={errors}
    />
  );
};

export default CheckboxField;
